import { jsx as _jsx } from "react/jsx-runtime";
import InfoTag from '../InfoTag';
import ScrollableRow from '../ScrollableRow';
const RallyTargetGroupsRow = ({ targetGroups }) => {
    return (!!targetGroups.length && (_jsx("div", { className: "rally-target-groups-row", children: _jsx(ScrollableRow, { children: targetGroups.map((targetGroup) => (_jsx(InfoTag, { backgroundColor: '#95C11F', textContent: targetGroup.title }, String(targetGroup.uid)))) }) })));
};
export default RallyTargetGroupsRow;
